module.exports = __webpack_public_path__ + "img/sn.95f777a1.png";